import { Component, OnInit, ElementRef } from '@angular/core';
import { Location } from '@angular/common';
import { AppService } from 'app/services/app/app.service';
import { Log } from 'app/core/logging/log';

@Component({
    selector: 'app-navbar-admin',
    templateUrl: './navbar-admin.component.html',
    styleUrls: ['./navbar-admin.component.scss']
})
export class NavbarAdminComponent implements OnInit {
    private toggleButton: any;
    private sidebarVisible: boolean;

    constructor(
        public location: Location, 
        private element : ElementRef,
        public appService: AppService) {
        this.sidebarVisible = false;
    }

    ngOnInit() {
        Log.debug("NavbarAdminComponent");
        const navbar: HTMLElement = this.element.nativeElement;
        this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
    }

    sidebarOpen() {
        const toggleButton = this.toggleButton;
        const html = document.getElementById('navbarAdminNav');

        setTimeout(function(){
            toggleButton.classList.add('toggled');
            html.classList.remove('collapse');
        }, 500);
        html.classList.add('nav-open');

        this.sidebarVisible = true;
    };
    sidebarClose() {
        const html = document.getElementById('navbarAdminNav');
        this.toggleButton.classList.remove('toggled');
        this.sidebarVisible = false;
        html.classList.remove('nav-open');
        html.classList.add('collapse');
    };
    sidebarAdminToggle() {
        Log.debug("sidebarAdminToggle", {sidebarVisible:this.sidebarVisible});
        // const toggleButton = this.toggleButton;
        // const body = document.getElementsByTagName('body')[0];
        if (this.sidebarVisible === false) {
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
    };
    isHome() {
      var titlee = this.location.prepareExternalUrl(this.location.path());
      if(titlee.charAt(0) === '#'){
          titlee = titlee.slice( 1 );
      }
        if( titlee === '/home' ) {
            return true;
        }
        else {
            return false;
        }
    }
    isDocumentation() {
      var titlee = this.location.prepareExternalUrl(this.location.path());
      if(titlee.charAt(0) === '#'){
          titlee = titlee.slice( 1 );
      }
        if( titlee === '/documentation' ) {
            return true;
        }
        else {
            return false;
        }
    }

}
